import type { ClientStatus, ClientStatusApproval } from './types';

/** The words the status card uses, shared by the React card and the /chat template so they cannot drift. */
export const CLIENT_STATUS_DRY_RUN_LINE = 'Dry run: this is a preview, nothing will be changed';

const WORD: Record<ClientStatus, string> = { active: 'Active', paused: 'Paused', offboarded: 'Offboarded' };

const word = (status: ClientStatus | null) => (status ? WORD[status] : 'unknown');

export function clientStatusGroupLabel(card: ClientStatusApproval): string {
  return card.kind === 'offboard_client'
    ? 'Approve or decline offboarding this client'
    : 'Approve or decline reactivating this client';
}

export function clientStatusLine(card: ClientStatusApproval): string {
  return `Status: ${word(card.statusBefore)} to ${word(card.statusAfter)}`;
}

export function clientStatusTitle(card: ClientStatusApproval): string {
  return card.client.name?.trim() || card.client.website;
}

/** The website under the title, only when the title is a name (otherwise it would say the same twice). */
export function clientStatusSubtitle(card: ClientStatusApproval): string | null {
  return clientStatusTitle(card) === card.client.website ? null : card.client.website;
}
